import Handler from "../Handler";

class FavouriteSaveAckHandler extends Handler {
  execute(message) {
    let parsedData = JSON.parse(message);
    this.service.processFavouriteSaveAckData(parsedData);
  }
}

export default FavouriteSaveAckHandler;

// favoritesaveack --- {"gameDefId":771,"status":200} added case
// favoritesaveack --- {"gameDefId":771,"status":201} removed case
// favoritesaveack --- {"gameDefId":771,"status":800} failure case
